const programRequestsRoutes = async () => [{
  path: '/p/:userId/:decision/:programId',
  name: 'userProgramRequestDecision',
  component: () => import(/* webpackChunkName: "programRequests" */ '../views/ProgramRequestsDecision.vue'),
  props: true,
}];

export default programRequestsRoutes;
